import { FC } from 'react';
import { UseObjectFormObject, useObjectForm } from '@app/hooks';
import { VariableAutocomplete } from '@app/page-components/shared';
import {
  ArgumentInput,
  ModuleReferenceObjectConfig,
  ModuleVariableReference,
  ValueOrVariableType,
  VariableReferenceScope
} from '@app/types';
import { ModuleOutputsForm } from '../ModuleOutputsForm';
import { ArgumentInputsForm } from './ArgumentInputsForm';
import { NodeFooter } from './NodeFooter';
import { NodeHeader } from './NodeHeader';

export type ModuleReferenceNodeModelFormProps = {
  object: UseObjectFormObject<ModuleReferenceObjectConfig>;
};

export const ModuleReferenceNodeModelForm: FC<ModuleReferenceNodeModelFormProps> = ({
  object
}) => {
  const {
    form: formLabels,
    property: propertyLabels
  } = window.l;
  const { createSubmitHandler, getControlProps } = useObjectForm({
    object,
    validate: ({ moduleReference }) => {
      return {
        moduleReference: (moduleReference) ? null : formLabels.no_empty
      };
    }
  });
  const moduleReferenceField = getControlProps('moduleReference');
  const inputsField = getControlProps('inputs', { syncOn: 'change' });

  return (
    <form className="flex-column flex-gap" onSubmit={createSubmitHandler()}>
      <NodeHeader getControlProps={getControlProps} />
      <VariableAutocomplete
        {...moduleReferenceField}
        label={propertyLabels.module_reference}
        onChange={({ varName }) => {
          moduleReferenceField.onChange(varName);
        }}
        placeholder="E.g. app.name, mod.name"
        tooltip="The module reference to use for this node."
        value={{
          type: ValueOrVariableType.variable,
          varName: moduleReferenceField.value
        }}
      />
      <ArgumentInputsForm
        {...inputsField}
        argumentScope={[VariableReferenceScope.module]}
        label={propertyLabels.inputs}
        onChange={(value) => {
          // This can be typed this way due to `argumentScope` being set.
          inputsField.onChange(value as (
            ArgumentInput
            & { argumentName: ModuleVariableReference; }
          )[]);
        }}
      />
      <ModuleOutputsForm
        {...getControlProps('outputs', { syncOn: 'change' })}
        moduleId={null}
      />
      <NodeFooter getControlProps={getControlProps} />
    </form>
  );
};
